/** 관리자 화면의 날짜,숫자 표기 , ko-KR 한 가지로 */
const DATE_TIME = new Intl.DateTimeFormat("ko-KR", { dateStyle: "short", timeStyle: "short" });
const DATE = new Intl.DateTimeFormat("ko-KR", { dateStyle: "medium" });

export const fmtDateTime = (v: string | null | undefined) => (v ? DATE_TIME.format(new Date(v)) : "없음");
export const fmtDate = (v: string | null | undefined) => (v ? DATE.format(new Date(v)) : "없음");
export const fmtInt = (n: number) => n.toLocaleString("ko-KR");
export const fmtNum = (n: number) => n.toLocaleString("ko-KR", { maximumFractionDigits: 6 });
